// src/components/BidCard.jsx
import React, { useState } from 'react';
import './BidCard.css';
import foodImage from '../image/food-img.png'; // replace with your actual image path
import { is, sl, tr } from 'date-fns/locale';
import { API_BASE_URL } from '../../utils';
import { IoLocationOutline } from "react-icons/io5";

const BidCard = ({ data, istableleads }) => {

    const url = `${API_BASE_URL}/master/assets/uploads/`;

    return (
        <>
            <div className="bid-card">
                <img src={url + data?.clubLogo} alt="Food" className="bid-card-image" />
                <div className="bid-card-info">
                    <div className="bid-card-header">
                        <div className='bid-card-text-sec'>
                            <h3 className="bid-title">{data?.clubName}</h3>
                            <p className="bid-subtitle">{data?.title}</p>
                            {istableleads && (
                            <p><IoLocationOutline/>{" "}{data?.distance} Km</p>
                            )}
                            <a href="#" className="view-link">View Details</a>
                        </div>
                        <div className="bid-amount">

                            {istableleads ? (
                                <>
                                {/* <span>Table Discount</span> */}
                                <strong className='tablediscount-box'>
                                    {data?.slab_details?.length
                                        ? data.slab_details[data?.slab_details.length - 1]?.discount
                                        : "N/A"}% <br/>OFF
                                </strong>
                                        </>
                            ) : (
                                <>
                                    <span>Bid Amount</span>
                                    <strong className="bid-amount">Rs {data?.price}/-</strong>
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BidCard;
